module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.error || _vm.errors.has(_vm.name)
    }
  }, [(!_vm.notLabel) ? _c('label', {
    attrs: {
      "for": _vm.name
    },
    on: {
      "click": function($event) {
        return _vm.$refs.input.focus()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.label || _vm.name))]), _vm._v(" "), (_vm.rules.includes('required')) ? _c('span', {
    staticClass: "label-required"
  }, [_vm._v(" *")]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.type) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue),
      expression: "innerValue"
    }],
    ref: "input",
    staticClass: "input",
    class: {
      'has-value': _vm.hasValue,
      'is-danger': _vm.error || _vm.errors.first(_vm.name)
    },
    attrs: {
      "id": _vm.name,
      "placeholder": _vm.placeholder,
      "v-validate": _vm.rules,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.innerValue) ? _vm._i(_vm.innerValue, null) > -1 : (_vm.innerValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.innerValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.innerValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.innerValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.innerValue = $$c
        }
      }
    }
  }) : ((_vm.type) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue),
      expression: "innerValue"
    }],
    ref: "input",
    staticClass: "input",
    class: {
      'has-value': _vm.hasValue,
      'is-danger': _vm.error || _vm.errors.first(_vm.name)
    },
    attrs: {
      "id": _vm.name,
      "placeholder": _vm.placeholder,
      "v-validate": _vm.rules,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.innerValue, null)
    },
    on: {
      "change": function($event) {
        _vm.innerValue = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue),
      expression: "innerValue"
    }],
    ref: "input",
    staticClass: "input",
    class: {
      'has-value': _vm.hasValue,
      'is-danger': _vm.error || _vm.errors.first(_vm.name)
    },
    attrs: {
      "id": _vm.name,
      "placeholder": _vm.placeholder,
      "v-validate": _vm.rules,
      "type": _vm.type
    },
    domProps: {
      "value": (_vm.innerValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.innerValue = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.error || _vm.errors.has(_vm.name)) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.error || _vm.errors.first(_vm.name)))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6357ef78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Form/TextInput.vue
// module id = 1139
// module chunks = 0